var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as PIXI from 'pixi.js';
import { BaseDeformer } from "./BaseDeformer";
import { DEFORMER_MANIP_ENUM } from "../enums";
var CenterScaleTransformDeformer = /** @class */ (function (_super) {
    __extends(CenterScaleTransformDeformer, _super);
    function CenterScaleTransformDeformer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._deformerType = [DEFORMER_MANIP_ENUM.MATRIX];
        _this._scale = new PIXI.Point(1, 1);
        _this._scaleAnchor = new PIXI.Point(0, 0);
        return _this;
    }
    Object.defineProperty(CenterScaleTransformDeformer.prototype, "scaleX", {
        get: function () {
            return this._scale.x;
        },
        set: function (value) {
            this._scale.x = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CenterScaleTransformDeformer.prototype, "scaleY", {
        get: function () {
            return this._scale.y;
        },
        set: function (value) {
            this._scale.y = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CenterScaleTransformDeformer.prototype, "scaleAnchorX", {
        get: function () {
            return this._scaleAnchor.x;
        },
        set: function (value) {
            this._scaleAnchor.x = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CenterScaleTransformDeformer.prototype, "scaleAnchorY", {
        get: function () {
            return this._scaleAnchor.y;
        },
        set: function (value) {
            this._scaleAnchor.y = value;
        },
        enumerable: false,
        configurable: true
    });
    CenterScaleTransformDeformer.prototype._uniforms = function () {
        return {
            scale: [this.scaleX, this.scaleY],
            scaleAnchor: [this.scaleAnchorX, this.scaleAnchorY],
        };
    };
    CenterScaleTransformDeformer.prototype._vertexHeader = function () {
        return "\n        uniform vec2 scale;\n        uniform vec2 scaleAnchor;\n        ";
    };
    CenterScaleTransformDeformer.prototype._vertBody = function () {
        return "\n        mat3 getTranslationMatrix".concat(this.index, "() {    \n            mat3 scaleMatrix = mat3(scale.x, 0, 0, 0, scale.y, 0, 0, 0, 1);\n            mat3 scaleAnchorMatrix = mat3(1, 0, 0, 0, 1, 0, scaleAnchor.x, scaleAnchor.y, 1);\n            mat3 invScaleAnchorMatrix = mat3(1, 0, 0, 0, 1, 0, -scaleAnchor.x, -scaleAnchor.y, 1);\n            mat3 combinedMatrix = scaleAnchorMatrix * scaleMatrix * invScaleAnchorMatrix;\n            return combinedMatrix;\n        }");
    };
    return CenterScaleTransformDeformer;
}(BaseDeformer));
export { CenterScaleTransformDeformer };
